import { globalDeleteService, globalGetService, globalPostService, globalPutService } from '../../utils/globalApiServices';
import { checkApiStatus } from '../../utils';
import { titanAviInstance } from '../../shared_elements/components';

export function getAssemblyUpcomingEventListApi(props={}, assemblyType=""){
  this.setState({ pageLoader:true })
  globalGetService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/new-upcoming-events/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ pageLoader:false, upcomingEvents: response.data.data.upcoming_events })
    } else {
      this.setState({ pageLoader:false })
    }
  })
}
export function getAssemblyEventListApi(props={}, assemblyType=""){
  this.setState({skeletonLoader:true});
  globalGetService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/shopvisit/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({skeletonLoader:false, eventHistories: response.data.data})
    } else {
      this.setState({skeletonLoader:false})
    }
  })
}
export function getAssemblyShopVisitApi(props={}, assemblyType=''){
  this.setState({
    pageLoader:true
  })
  globalGetService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/shopvisit/${props.match.params.id}/`)
  .then(response => {
    this.setState({
      pageLoader:false
    })
    if(checkApiStatus(response)){
      this.setState({
        event: response.data.data,
      })
    }
  })
}
export function addEditAssemblyShopVisitApi(props={}, data={}, assemblyType=''){
  return new Promise(
    function(resolve, reject){
      let payload = Object.assign({}, data)
      if(data.id){
         payload = {
           ...payload,
            fh_event: assemblyType === 'apu' &&  data.csn === 0 || data.csn === '' ? true  :  false  || data.event_id === 70 && true ,
            fc_event: assemblyType === 'lg' &&  data.tsn === 0 || data.tsn === '' ? true  :  false   || data.event_id === 71 && true ,
            tsn: assemblyType === 'lg'  &&  data.tsn.length === 0 ? 0  : ''  ||  data.event_id === 71 ? 0 : data.tsn,
            csn: assemblyType === 'apu' && data.csn.length === 0  ? 0  : ''  ||  data.event_id === 70 ? 0 : data.csn,
         }
        delete payload['event'];
        globalPutService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/shopvisit/${data.id}/`, payload)
        .then(response => {
          resolve(response)
        })
      }else{
        payload = {
          ...payload,
           event_id: data.event.event_id,
           tsn: assemblyType === 'lg' && data.tsn === 0 || data.tsn === '' ? 0  : ''  ||  data.event_id === 71 ? 0 : data.tsn,
           csn: assemblyType === 'apu' && data.csn === 0 || data.csn === '' ? 0  : ''  ||  data.event_id === 70 ? 0 : data.csn,
           fh_event: assemblyType === 'apu' &&  (data.csn === "0" || data.csn === "") ? true  :  false  || data.event_id === 70 && true ,
           fc_event: assemblyType === 'lg' && (data.tsn === "0" || data.tsn === "") ? true : false  || data.event_id === 71 && true 
        }
         delete payload['event'];
        globalPostService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/shopvisit/`, payload)
        .then(response => {
          resolve(response);
        })
      }
    }
  )
}
export function addEditAssemblyClaimApi(props={},data={}){
  return new Promise(
    function(resolve,reject){
      if(data.id){
        globalPutService(`maintenance/${props.match.params.assetType}/asset/${props.match.params.assetSlug}/claims/${data.id}/`, data)
        .then(response => {
          resolve(response)
        })
      }else{
        globalPostService(`maintenance/${props.match.params.assetType}/asset/${props.match.params.assetSlug}/claims/`, data)
        .then(response => {
          resolve(response)
        })
      }
    }
  )
}
export function getAssemblyClaimListApi(props={}, query={}){
  this.setState({pageLoader: true})
  globalGetService(`maintenance/${props.match.params.assetType}/asset/${props.match.params.assetSlug}/claims/`, {shop_visit_id:props.match.params.id})
  .then(response => {
    this.setState({pageLoader: false})
    if(checkApiStatus(response)){
      this.setState({
        claims: response.data.data
      })
    }
  })
}
export function toggleAssemblyClaimStatusApi(props={}, id, data={},attachedData={}){
  this.setState({pageLoader: true})
  const toggleFnc = (key, status) => {this.setState({ [key]: status })}
  (titanAviInstance && id?.status?.value !==3 ? globalPutService(`/maintenance/${id?.asset_type}/asset/${id?.asset_slug}/claims/${id?.id}/approval-by-all/`, data):globalPostService(`maintenance/claim/${id?.id}/update-status/`, data)).then(response => {
      if (checkApiStatus(response)) {
        this.setState(prevState => ({
          ...prevState,
          claims: prevState.claims.map(claim => claim.id === id?.id ? response.data.data : claim),
        }));
        if (attachedData?.attachedDoc?.length > 0) {
          addAttachmentApi("Event Status updated Successfully", response?.data?.history?.id, attachedData?.props, attachedData?.attachedDoc, "claimstatushistory", toggleFnc)
        } else {          
          toggleFnc("pageLoader", false)
          if(attachedData?.getResponseBack){
            attachedData?.getResponseBack()
          }
          this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
        // this.props.enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
      } else {
        this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      }
      this.getAssemblyClaimListApi(this.props)
    })
}
export function getAssemblyEventsApi(props={}, assemblyType=""){
  globalGetService(`maintenance/asset-type/${assemblyType}/asset/${props.match.params.assetSlug}/events/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState(prevState => ({
        mntEvents:response.data.data
      }))
    }
  })
}
export function getClaimListApi(props={}, query={}){
  this.setState({ claimsLoader: true })
  globalGetService(`maintenance/${props.match.params.assetType}/asset/${props.match.params.assetSlug}/claims/`, query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ claimsLoader: false, claims: response.data.data })
    } else {
      this.setState({ claimsLoader: false })
    }
  })
}

export function deleteAttachmentApi(deleteItem,moduleType,moduleNumber, toggleFnc) {
  toggleFnc("buttonLoader",true)
  globalDeleteService(`maintenance/attachments/${moduleType}/${moduleNumber}/${deleteItem?.uuid}/`)
    .then(response => {
      toggleFnc("deleteAttachmentModal", false);
      toggleFnc("buttonLoader",false)
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
      } else {
        this.props.enqueueSnackbar(response.data.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
      }
    })
};

export function addAttachmentApi(responseMessage,modelNumber,props,attachedDoc,modelType,toggleFnc) {
  const { getResponseBack} = props;
  let formdata = new FormData();
  attachedDoc?.forEach(item => {
    formdata.append('files', item);
  });
  toggleFnc("pageLoader",true)
  globalPostService(`maintenance/attachments/${modelType}/${modelNumber}/`, formdata)
    .then(response => {
      if (response?.data?.statusCode === 200) {
        props?.enqueueSnackbar(responseMessage, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        if(getResponseBack){
          getResponseBack();
        }
      } else {
        props?.enqueueSnackbar(response?.data?.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
      }
      toggleFnc("pageLoader",false)
    });
}

export function getModuleDescriptionApi(params, query) {
  globalGetService(`console/v2/asset/engine/${params}/llp/`, { for_reserve_account: query })
    .then(response => {
      if (checkApiStatus(response)) {
        const updatedResponse = response?.data?.data?.map(item => ({
          label: item,
          value: `${item?.toLowerCase()}_event`
        }));
        this.setState({
          tableLoader: false,
          moduleList: updatedResponse
        })
      }
    })
}
export function getEngineModuleConstant() {
    globalGetService(`console/get-constants/?constant_type=psrv_claim_module`)
    .then(response=>{
      if (checkApiStatus(response)) {
      this.setState({
        moduleConstantList: response?.data?.data
      })
    }})
}

export function getCashflowApi(assetType,assetSlug,shopvisitId) {
    globalGetService(`/maintenance/asset-type/${assetType}/asset/${assetSlug}/shopvisit/${shopvisitId}/cashflow-card/`)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState({
          cashflowData: response?.data?.data
        })
      }})
}
export function getMajorAssemblyApi(assetType,assetSlug,query) {
    globalGetService(`/maintenance/${assetType}/asset/${assetSlug}/reserve_rates/`,query)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState({
          majorAssembly: response?.data?.data
        })
      }})
}

export function getMajorAssemblies(props) {
  globalGetService(`console/v2/${props?.assetType}/${props?.assetSlug}/major-assemblies/`)
    .then(response => {
      if (checkApiStatus(response)) {
        let data = response.data.data
        this.setState({ maList: data });
      }
    })
}